import { Injectable } from '@angular/core';
import { HttpClient } from '@angular/common/http';
import { config } from '../../../../config';

export enum TaxInvoice {
  clientPayments = 'client-payments'
}

@Injectable()
export class CommandService {
  constructor(private http: HttpClient) { }

  processPayouts(frequency: string) {
    return this.http
      .post<any>(`${config.apiLocation}/admin/commands/process-payouts`, {frequency});
  }

  generateTaxInvoices(payment: TaxInvoice) {
    return this.http
      .get<any>(`${config.apiLocation}/admin/commands/generate-invoices/${payment}`);
  }

  settings(command: string) {
    return this.http
      .get<any>(`${config.apiLocation}/admin/commands/settings?command=${command}`);
  }

  update(command: string, data: Object) {
    return this.http
      .post<any>(`${config.apiLocation}/admin/commands/update`, { command, ...data });
  }

  bulksendnor(file: File) {
    const body = new FormData();
    body.append('file', file, file.name);

    return this.http
      .post<{ data: any}>(`${config.apiLocation}/v1/admin/bulksendnor`, body)
      .map(res => res.data);
  }
}



// WEBPACK FOOTER //
// ./src/app/core/data/commands/command.service.ts